<template>
      <div class="switch-box">
        <el-row>
          <p style="">
            {{ data.label }}
          </p>
        </el-row>
        <el-form-item>
          <el-switch
            :disabled="disabled"
            size=""
            style="
              --el-switch-on-color: #13ce66;
              --el-switch-off-color: #ff4949;
            "
            active-text="Si"
            inactive-text="No"
            v-model="data.model"
            @change="saveDataToLocalStorage(data.model, data.name)"
          />
        </el-form-item>
        <el-form-item v-if="data.model" :label="data.companyDataRetention.label" style="width:90%">
          <el-col :span="8">
            <el-select
              multiple
              :disabled="disabled"
              :multiple-limit='2'
              style="margin-left:11%"
              :class="verifyFields (data.companyDataRetention, validation) ? 'input-warning':''"
              :placeholder="data.companyDataRetention.placeholder"
              v-model="data.companyDataRetention.model"
              @change ="generateAliquotOptions(data.companyDataRetention.model)"
              @input="saveDataToLocalStorage(data.companyDataRetention.model,data.companyDataRetention.name)"
              :required="data.companyDataRetention.required"
            >
              <el-option
                v-for="(option) in data.companyDataRetention.optionValue"
                :key="option.idRetentionRegime"
                :label="option.retentionRegime"
                :value="option.idRetentionRegime"
              />
            </el-select>
          </el-col>
          <el-col :span="23">
            <el-alert v-if="verifyFields (data.companyDataRetention, validation)" :title="`Falta completar: ${data.companyDataRetention.label}`" type="error" class="message-warning" :closable="false"/>
          </el-col>
      </el-form-item>
        <el-form-item v-if="data.model" :label="data.companyRetentionFields.label" style="width:90%">
          <el-col :span="8">
            <el-select
              :disabled="disabled"
              style="margin-left:11%"
              :class="verifyFields (data.companyRetentionFields, validation) ? 'input-warning':''"
              :placeholder="data.companyRetentionFields.placeholder"
              v-model="data.companyRetentionFields.model"
              :required="data.companyRetentionFields.required"
              @input="saveDataToLocalStorage(data.companyRetentionFields.model,data.companyRetentionFields.name)"
            >
              <el-option
                v-for="(option) in options"
                :key="option.idCategoryRetain"
                :label="option.categoryRetain"
                :value="option.idCategoryRetain"
              />
            </el-select>
          </el-col>
          <el-col :span="23">
            <el-alert v-if="verifyFields (data.companyRetentionFields, validation)" :title="`Falta completar: ${data.companyRetentionFields.label}`" type="error" class="message-warning" :closable="false"/>
          </el-col>
      </el-form-item>
        <p v-if="(data.companyDataRetention.model.includes('Retención Detracciones') && data.model)">Suspensión</p>
        <div v-if="(data.companyDataRetention.model.includes('Retención Detracciones') && data.model)">
        <el-row>
          <el-col :span="18">
          <el-form-item :label="data.companySuspensionNumber.label">
              <el-input :disabled="disabled" @input="saveDataToLocalStorage(data.companySuspensionNumber.model,data.companySuspensionNumber.name)" :class="verifyFields (data.companySuspensionNumber, validation) ? 'input-warning':''" :type="data.companySuspensionNumber.type" v-model="data.companySuspensionNumber.model" style="margin-left:4%"/>
          </el-form-item>
          <el-alert v-if="verifyFields (data.companySuspensionNumber, validation)" :title="`Falta completar: ${data.companySuspensionNumber.label}`" type="error" class="message-warning" :closable="false" style="margin-left:34%; margin-top:-20px; margin-bottom:10px"/>
          </el-col>
          <el-col :span="24">
           <el-date-picker style="margin-left: 2.5%"
            :disabled="disabled"
            format="dd/MM/yyyy"
            value-format="yyyy-MM-dd"
            v-model="data.firstDate.model"
            :class="verifyFields (data.firstDate, validation) ? 'input-warning':''"
            type="date"
            placeholder="Desde"
            @input="saveDataToLocalStorage(data.firstDate.model,data.firstDate.name)"
          />
          <el-date-picker
          :disabled="disabled"
          v-model="data.lastDate.model"
          format="dd/MM/yyyy"
          value-format="yyyy-MM-dd"
          type="date"
          :class="verifyFields (data.lastDate, validation) ? 'input-warning':''"
          placeholder="Hasta"
          :picker-options="disabledDates"
          @input="saveDataToLocalStorage(data.lastDate.model,data.lastDate.name)"
          />
          </el-col>
          </el-row>
          <el-row>
            <el-col :span="12" style="margin-top: 25px">
              <pdf-file
              :disabled="disabled"
              v-bind:pdfFilePath.sync="data.pdfSuspension.model"
              :habModificaPdf="habModificaPdf"
              :titulo="data.pdfSuspension.label"
              :id="data.pdfSuspension.label"
              :prop="data.pdfSuspension.name"
              :country="'PER'"
                      />
            </el-col>
            <el-alert v-if="verifyFields (data.pdfSuspension, validation)" :title="`Falta completar: ${data.pdfSuspension.label}`" type="error" class="message-warning" :closable="false" style="margin-top: 40px"/>
          </el-row>
        </div>
      </div>
</template>

<script>
import PdfFile from '../PdfFile.vue'
import { persistToNewProviderStorage, saveDataToLocalStorage } from '../helpers/utils.js'
import api from '../../api'
export default {
  components: {
    'pdf-file': PdfFile
  },
  data () {
    return {
      disabledDates: {
        disabledDate (time) {
          return time.getTime() < Date.now()
        }
      },
      habModificaPdf: true,
      options: [],
      fieldAlert: '',
      retentionAliquotPeru: [],
      percepCobranza: [],
      impuestoSolid: [],
      renta4ta: [],
      rentaPersonas: [],
      rentaNoDomiciliados: [],
      retencionDetraccion: []
    }
  },
  props: {
    data: {
      type: Object,
      required: true
    },
    validation: {
      type: Boolean
    },
    disabled: {
      type: Boolean
    },
    denominaciones: {
      type: [Array, Object]
    }
  },
  computed: {},
  methods: {
    getRetentionAliquotPeru () {
      api.request('GET', `api/getRetentionAliquotPeru`)
        .then(response => {
          var data = response.data
          if (data.error) {
            return
          }
          if (data) {
            this.retentionAliquotPeru = data
            // console.log('retentionAliquotPEru', data)
            this.generateAliquotOptions(this.data.companyDataRetention.model)
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    generateAliquotOptions (selectedModels) {
      // SWITCH-retention
      console.log('selectedModels', selectedModels)
      this.options = []
      // console.log(this.retentionAliquotPeru.data)
      this.data.companyDataRetention.model.forEach((model) => {
        this.retentionAliquotPeru.data.forEach((ret) => {
          if (model === ret.idRetentionRegime) {
            this.options.push(ret)
          }
        })
      })
    },
    disabledDate (date) {
      // SWITCH-retention
      const fromDate = date
      return date && date.valueOf() < fromDate.valueOf()
    },
    verifyFields (data, validation) {
      if (data.model === null || data.model === undefined) {
        data.model = ''
      }
      // console.log(data.model)
      return (data.model.length === 0 && validation === false && data.required)
    },
    persistToNewProviderStorage,
    saveDataToLocalStorage
  },
  watch: {
    'data.companyDataRetention.model' (newVal) {
      this.generateAliquotOptions(newVal)
    },
    'data.model' (newVal) {
      if (this.data.companyDataRetention.model.includes('Retención Detracciones')) {
        this.generateAliquotOptions(this.data.companyDataRetention.model)
      }
    }
  },
  mounted () {
    this.getRetentionAliquotPeru()
    // console.log('deno', this.$props.denominaciones)
    // console.log('data', this.$props.data)
  }
}
</script>



// WEBPACK FOOTER //
// SwitchRetention.vue?73e35bbc